__turbopack_context__.v({
  "contain": "image-module-scss-module__vdHUEW__contain",
  "cover": "image-module-scss-module__vdHUEW__cover",
  "image": "image-module-scss-module__vdHUEW__image",
  "picture": "image-module-scss-module__vdHUEW__picture",
  "responsive-image": "image-module-scss-module__vdHUEW__responsive-image",
});
